// $('.shizhongqu .banquan_logo img').attr('src','http://www.shizhong.gov.cn/picture/0/1805241431373556084.png')
// $('.shizhongqu .banquan_wzzc img').attr('src','http://www.shizhong.gov.cn/picture/0/1805241431373302368.jpg')
// $('.tianqiaoqu .foot01 tbody tr:eq(1) td:eq(0) img').attr('src','http://www.tianqiao.gov.cn/picture/663/2210241504272878021.png')
// $('.lichengqu .fl:eq(0) img').attr('src','http://www.licheng.gov.cn/picture/22/1805171727379157533.png')
// $('.lichengqu .fl:eq(1) img').attr('src','http://www.licheng.gov.cn/picture/22/1805171727379279693.png')
// $('.lichengqu .address img').attr('src','http://www.licheng.gov.cn/picture/0/1902121009252466436.png')
// $('.changqingqu .dzbz img').attr('src','http://www.jncq.gov.cn/picture/223/07eb19c791b94629a4a7e92ddea17a8b.png')
// $('.changqingqu .jiucuo1 img').attr('src','http://www.jncq.gov.cn/picture/223/a9cfd472e9a14340a80af014640114a6.png')
// $('.changqingqu .two img').attr('src','http://www.jncq.gov.cn/picture/0/1812141409179565441.png')
// $('.pingyinxian .dzjg img').attr('src','http://www.pingyin.gov.cn/picture/846/2110281705116108568.png')
// $('.pingyinxian .zfzc img').attr('src','http://www.pingyin.gov.cn/picture/846/2110281705115952999.png')
// $('.shanghexian .footer .linkmenu ul li').off('click').on('click', function() {
//     $(this).children('ul').is(':visible') ? $(this).children('ul').hide() : $(this).children('ul').show()
// })
// $('.gaoxinqu .ad_info a img').attr('src','http://innovation.jinan.gov.cn/picture/0/359344d3ecaa4d27badcde59d61cdad2.png')
// $('.gaoxinqu .pimg>a img').attr('src','http://innovation.jinan.gov.cn/picture/0/s_d186e8dee209490a84bc28e75745442c.png')
// $('.zimaoqu .am-text-center p a img').attr('src','http://ftz.jinan.gov.cn/picture/785/2012141429363451677.png')
// $('.nanshanqu .banquan-l a:eq(0) img').attr('src','http://jnns.jinan.gov.cn/picture/947/2205251752281109005.png')
// $('.nanshanqu .banquan-l a:eq(1) img').attr('src','http://jnns.jinan.gov.cn/picture/947/2205251752281569175.png')
// $('.nanshanqu .banquan-r1 a img').attr('src','http://jnns.jinan.gov.cn/picture/947/2206141121059531009.png')
// $('.nanshanqu .banquan-r2 img').attr('src','http://jnns.jinan.gov.cn/picture/947/2205251752282457401.png')
// $('.qibuqu>a img').attr('src','http://jnxxq.jinan.gov.cn/picture/0/2105270958431466227.png')

$('.shanghexian .footer .caret').css('background','url(http://www.shanghe.gov.cn/picture/988/2209221401016916638.png)')
for (var item in footerSites) {
    let _ele = $(`.${item}`)

    for (var i = 0; i < _ele.find('a').length;i++) {
        let url = _ele.find('a').eq(i).attr('href');
        if (url?.charAt(0) == '/') {
            _ele.find('a').eq(i).attr('href',footerSites[item]+url)
        }
    }

    for (var i = 0; i < _ele.find('img').length;i++) {
        let url = _ele.find('img').eq(i).attr('src');
        if (url?.charAt(0) == '/') {
            _ele.find('img').eq(i).attr('src',footerSites[item]+url)
        }
    }
}